// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1u-0";
export var spinnerContainer = "_1u-1";